var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrod7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_18959)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 49H-2V309H640V49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.574 48.9257V308.574H-2.07449V48.9257H642.574ZM643 48.5H-2.5V309H643V48.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.25 48.5H158.769V273.884H320.25V48.5Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.731 48.5H320.25V273.884H481.731V48.5Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 139.654V169.489V180.494V189.507V203.237V211.612V225.341V274H482V49H641V130.633",
    fill: "#23A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 139.654V169.489V180.494V189.507V203.237V211.612V225.341V274H482V49H641V130.633",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.769 48.5H-2.5V273.884H158.769V48.5Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.769 69.2506L45.1062 130.745L158.769 146.102V155.552L42.6637 139.867L90.7294 216.544L82.7979 221.52L34.7067 144.796L15.4523 234.813L6.29956 232.855L25.439 143.37L-2.5 169.122V156.39L21.0265 134.699L24.0221 131.473L-2.5 109.105V96.85L25.9241 120.827L0.406239 48.5H10.3334L33.4982 114.161L56.88 48.5H66.82L45.5104 108.338L101.091 48.5H113.864L49.6464 117.647L158.769 58.605V69.2506Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.357 127.895C101.357 127.895 102.014 120.796 111.052 112.209C119.214 104.459 133.557 107.545 138.807 122.223C142.574 132.76 140.332 146.079 137.264 158.978C134.197 171.877 131.787 176.361 131.787 195.604C131.787 208.177 138.562 217.325 158.769 223.254L158.691 273.881H17.7075L18.9146 271.03L26.0755 238.742L60.2818 231.515L104.063 216.738L98.9858 202.888C95.8714 193.298 94.9264 169.656 101.353 161.572L100.382 146.799L101.357 127.895Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7438 251.68C26.9028 246.232 7.28674 220.361 12.5801 198.367H120.328C123.668 234.637 93.0485 257.554 58.7438 251.68Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.35965 232.914C-1.35965 232.914 18.3245 213.342 27.8432 208.754C23.4944 217.454 22.9072 222.039 22.9072 222.039L37.3661 214.398L28.7878 229.798L46.0635 220.157L38.5405 233.795L53.3483 225.563C35.7194 244.611 23.718 266.578 21.25 273.75H-2.40977L-1.35965 232.914Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.131 230.617C150.131 230.617 127.762 217.992 109.75 211.914C111.928 215.243 119.732 227.408 119.732 227.408L98.9674 221.27L111.818 237.164L88.9891 232.46L99.1971 245.881L79.4662 242.668L113.192 272.706",
    fill: "#23A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.131 230.617C150.131 230.617 127.762 217.992 109.75 211.914C111.928 215.243 119.732 227.408 119.732 227.408L98.9674 221.27L111.818 237.164L88.9891 232.46L99.1971 245.881L79.4662 242.668L113.192 272.706",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1772 118.867C94.6909 121.081 108.273 129.121 107.324 144.602C106.312 161.194 100.04 163.791 93.2144 162.867C85.3765 161.943 70.4368 154.843 70.4368 154.843L92.0144 146.079L71.1772 118.867Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.796 110.232C118.685 99.7477 125.281 91.4858 140.689 95.2358C139.421 96.9597 135.902 103.289 135.902 103.289L144.161 103.498L138.957 110.925C138.957 110.925 145.48 110.785 147.356 113.147C138.263 118.008 138.336 129.531 138.336 129.531L128.617 117.383L121.885 113.773L119.796 110.232Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.039 142.398C124.775 142.398 129.425 137.746 129.425 132.007C129.425 126.269 124.775 121.617 119.039 121.617C113.302 121.617 108.652 126.269 108.652 132.007C108.652 137.746 113.302 142.398 119.039 142.398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.302 132.004C127.302 136.559 123.596 140.266 119.039 140.266C118.49 140.266 117.954 140.211 117.434 140.109C121.166 139.3 123.966 135.972 123.966 132.004C123.966 128.037 121.166 124.709 117.434 123.896C117.954 123.794 118.49 123.738 119.039 123.738C123.596 123.738 127.302 127.446 127.302 132.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9285 195.527C24.9285 196.557 24.703 197.523 24.303 198.37H15.0183C14.6183 197.523 14.3928 196.557 14.3928 195.527C14.3928 192.202 16.7502 189.508 19.6607 189.508C22.5711 189.508 24.9285 192.202 24.9285 195.527Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.864 197.707C35.8002 198.017 35.7109 198.32 35.613 198.609H26.0135C25.7156 197.745 25.5454 196.779 25.5454 195.766C25.5454 191.965 27.9027 188.883 30.8132 188.883C33.3493 188.883 35.4726 191.228 35.9704 194.352C35.7364 195.378 35.6896 196.523 35.864 197.707Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5742 198.607H36.0427C35.9746 198.33 35.9151 198.045 35.8725 197.755C35.8683 197.738 35.8683 197.721 35.864 197.704C36.0087 197.091 36.081 196.44 36.081 195.763C36.081 195.278 36.0427 194.806 35.9704 194.35C36.4725 192.141 37.8341 190.485 39.6426 190.209C42.1105 189.83 44.5487 192.141 45.3487 195.482C45.3487 195.487 45.3487 195.495 45.3529 195.499C45.3869 195.708 45.4295 195.912 45.4763 196.117C45.4763 196.121 45.4763 196.129 45.4806 196.134C45.4848 196.181 45.4933 196.227 45.5018 196.274C45.6252 197.079 45.6465 197.862 45.5742 198.607Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1184 190.562C55.4971 191.328 54.9354 192.192 54.4589 193.141C53.5483 194.959 53.076 196.848 53.0079 198.606H46.3529C45.9784 197.853 45.6806 197.023 45.4806 196.133C45.4763 196.129 45.4763 196.121 45.4763 196.116C45.4423 195.908 45.3997 195.699 45.3529 195.499C45.3487 195.495 45.3487 195.486 45.3487 195.482C45.3359 195.406 45.3231 195.333 45.3104 195.257C44.604 190.659 46.638 186.535 49.8548 186.041C52.3398 185.658 54.8035 187.556 56.1184 190.562Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1692 198.373H70.2591C69.9782 197.637 69.7655 196.841 69.6378 196.002C69.5527 195.449 69.5059 194.896 69.5017 194.359V194.342C69.4974 194.117 69.5017 193.895 69.5102 193.674V193.619C69.6889 190.056 71.5399 187.191 74.1866 186.787C76.0928 186.493 77.9821 187.545 79.3565 189.405C80.2969 190.682 80.9947 192.338 81.2841 194.21C81.5096 195.679 81.4543 197.101 81.1692 198.373Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4741 198.419C91.4783 198.483 91.4868 198.542 91.4911 198.606H81.0959C81.381 197.333 81.4363 195.912 81.2108 194.443C80.9214 192.57 80.2236 190.914 79.2832 189.637C80.1725 187.403 81.7171 185.849 83.6617 185.551C87.1594 185.015 90.6614 188.756 91.6783 193.996C91.4145 195.354 91.3337 196.852 91.4741 198.419Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.474 196.106V196.11C103.354 196.898 103.295 197.736 103.295 198.605H91.8656C92.0145 197.349 91.9975 195.995 91.7847 194.608C91.7549 194.399 91.7166 194.195 91.6783 193.995C92.3549 190.492 94.2357 187.951 96.6526 187.733C99.7588 187.457 102.665 191.117 103.474 196.106Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.656 198.608H103.695C103.691 198.191 103.669 197.77 103.631 197.34C103.593 196.923 103.542 196.514 103.474 196.114V196.11C104.022 192.428 105.805 189.729 108.137 189.52C111.167 189.252 114.018 193.279 114.656 198.608Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4369 193.85V193.906C69.4284 194.127 69.4241 194.348 69.4284 194.574V194.591C69.3603 195.889 69.0752 197.251 68.5561 198.605H53.0079C53.076 196.847 53.5483 194.957 54.4589 193.14C54.9355 192.19 55.4972 191.326 56.1184 190.56C58.88 187.151 62.85 185.657 65.9009 187.185C68.1689 188.321 69.3986 190.871 69.4369 193.85Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.711 192.357L153.488 175.625L155.003 182.359L114.52 197.435L112.711 192.357Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.803 180.42L144.288 186.35L148.097 184.932L145.225 179.016L141.803 180.42Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1968 66.82C17.7075 59.9074 5.37195 60.8608 5.37195 74.9287C5.37195 85.7743 13.5971 89.4733 18.4819 82.1989",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3578 64.9018C32.1408 64.0973 33.2429 63.7696 34.3449 63.8803C44.0891 64.889 44.9699 78.1396 39.6 84.1499C35.0726 89.2194 26.9368 86.1802 26.8645 76.4157C26.8134 69.9118 29.6218 66.6938 31.3578 64.9018Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6632 61.4141C48.9442 77.9805 51.7654 83.9737 59.4373 83.7949C70.3729 83.5438 68.6028 67.2923 68.0326 61.9206",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8407 86.5728C77.8407 86.5728 78.6407 69.5893 78.6407 64.5027C78.6407 59.4161 92.3634 58.3265 91.5634 66.9672C90.7635 75.608 80.3087 72.6071 80.3087 72.6071",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2062 72.7031L90.9124 84.9066",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.608 61.7578H122.272L120.783 85.2709L131.238 84.2834",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.238 73.1185L122.273 72.7227",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.265 81.7231C103.405 86.5756 114.788 85.2603 113.269 76.6579C112.243 70.8434 102.959 75.5426 103.184 67.1913C104.005 58.5633 114.707 61.4195 114.707 64.8119",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.553 81.8325C140.693 86.685 152.075 85.3697 150.556 76.7672C149.531 70.9528 140.246 75.652 140.472 67.3007C141.293 58.6727 151.994 61.5288 151.994 64.9213",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5408 156.079C45.5412 156.079 56.0801 145.536 56.0801 132.532C56.0801 119.527 45.5412 108.984 32.5408 108.984C19.5405 108.984 9.00159 119.527 9.00159 132.532C9.00159 145.536 19.5405 156.079 32.5408 156.079Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.05 188.2C226.05 188.2 223.523 208.427 224.055 215.34L223.982 217.996L268.487 219.167L289.107 212.254L289.009 207.223C289.009 207.223 291.107 180.347 289.009 131.797L237.675 117.27C231.186 124.003 229.786 135.292 229.986 141.289C227.089 133.696 220.2 121.309 204.022 121.705C187.844 122.105 173.164 135.892 174.861 161.665C175.589 172.77 175.176 189.418 199.018 190.397C207.715 190.754 217.055 189.899 226.05 188.2C227.187 187.988 228.314 187.762 229.437 187.519Z",
    fill: "#98282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.05 188.2C226.05 188.2 223.523 208.427 224.055 215.34L223.982 217.996L268.487 219.167L289.107 212.254L289.009 207.223C289.009 207.223 291.107 180.347 289.009 131.797L237.675 117.27C231.186 124.003 229.786 135.292 229.986 141.289C227.089 133.696 220.2 121.309 204.022 121.705C187.844 122.105 173.164 135.892 174.861 161.665C175.589 172.77 175.176 189.418 199.018 190.397C207.715 190.754 217.055 189.899 226.05 188.2ZM226.05 188.2C227.187 187.988 228.314 187.762 229.437 187.519",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.831 70.1665C182.831 72.1798 182.18 74.0399 181.078 75.5467C179.419 77.8282 176.725 79.3095 173.691 79.3095C171.019 79.3095 168.619 78.1645 166.951 76.3385C165.458 74.7125 164.551 72.5459 164.551 70.1665C164.551 65.1182 168.64 61.0234 173.691 61.0234C178.738 61.0234 182.831 65.1182 182.831 70.1665Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.078 75.5458C179.419 77.8273 176.725 79.3086 173.691 79.3086C171.019 79.3086 168.619 78.1635 166.951 76.3375C168.083 75.5032 170.206 73.7112 170.798 71.6C169.938 70.9615 169.394 70.0293 169.394 68.995C169.394 67.0625 171.27 65.4961 173.585 65.4961C175.9 65.4961 177.776 67.0625 177.776 68.995C177.776 69.6334 177.568 70.2336 177.206 70.7487C177.687 72.1193 178.785 74.3582 181.078 75.5458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23 62.6406H194.35V78.1855H209.711",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35 70.4141H208.209",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.689 71.5977H222.889",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.314 68.21C234.825 67.4779 238.429 65.9625 238.505 63.2852C238.616 59.1648 227.472 60.8249 227.472 62.1955V78.6087C235.186 78.1873 240.731 75.5653 240.505 71.5982C240.348 68.8655 236.046 68.1504 232.314 68.21ZM232.314 68.21C230.629 68.2355 229.059 68.4271 228.042 68.6569",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.019 69.5352C255.04 69.1734 255.028 68.8116 254.964 68.4541C254.283 64.5423 252.47 62.2693 248.122 62.2267C243.607 62.1842 243.841 69.6544 244.271 72.2935C244.892 76.1031 249.424 77.1714 252.47 74.9878C254.53 73.5108 254.943 70.7696 255.019 69.5352Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.789 62.6877C265.687 62.6877 265.589 62.6962 265.491 62.7089C260.427 63.3517 258.462 70.0727 262.542 73.7206C266.653 77.394 272.801 73.9505 272.359 69.6471C271.665 62.9941 266.78 62.6791 265.789 62.6877Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.333 62.2305L279.431 78.1031",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.431 70.9718L292.205 63.293",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.064 67.1328C286.064 67.1328 287.771 73.9688 291.243 77.5443",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.472 65.0521C303.881 60.8126 297.2 63.06 297.387 65.9928C297.668 70.4664 305.204 65.9204 306.804 70.4664C308.591 75.553 301.953 79.8393 295.46 75.6934",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.225 139.203L228.991 117.269C237.458 93.1174 257.725 81.5396 281.346 88.2734C302.276 94.2368 315.531 115.864 309.225 139.203Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.991 117.267L166.951 100.305",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.708 119.362C267.991 119.362 273.895 113.457 273.895 106.171C273.895 98.8863 267.991 92.9805 260.708 92.9805C253.426 92.9805 247.522 98.8863 247.522 106.171C247.522 113.457 253.426 119.362 260.708 119.362Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.082 99.3948L256.189 97.7773L253.517 111.292C253.517 111.292 259.172 111.39 264.495 113.544",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.032 103.633L266.363 106.17",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.245 198.005C240.258 197.32 232.544 190.654 229.438 187.521C249.007 183.329 266.342 175.28 271.074 167.277C271.916 190.399 260.806 198.729 250.245 198.005Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.678 186.539L254.223 187.986C252.028 194.141 239.131 192 239.131 192C243.36 197.891 262.146 198.96 265.678 186.539Z",
    fill: "#E2442F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.7 185.25V190.026C244.241 190.324 242.803 190.511 241.871 190.511C241.871 190.511 241.871 187.881 241.871 186.246C243.288 185.957 244.569 185.608 245.7 185.25Z",
    fill: "#F4F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.113 183C251.113 183 250.977 185.903 250.977 188.053C250.7 188.504 249.628 188.972 248.283 189.381V184.324C250.096 183.592 251.113 183 251.113 183Z",
    fill: "#F4F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.177 211.914V217.107C251.849 217.733 249.871 222.36 246.849 220.474C243.756 218.546 238.867 219.661 235.905 223.432C233.016 222.028 227.927 218.92 222.353 224.101C220.149 223.654 214.302 221.657 208.383 231.128C204.528 233.346 200.056 233.567 201.226 238.675C199.996 239.275 197.269 242.416 198.69 245.996C188.652 244.081 181.044 240.931 179.865 236.061C180.002 234.61 180.248 233.163 180.606 231.728C185.023 214.102 231.191 213.131 256.177 211.914Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.177 246.465V259.401C248.9 263.768 220.629 261.27 207.988 258.047C196.967 255.234 185.584 251.646 181.044 249.262C179.946 244.984 179.431 240.498 179.865 236.062C183.401 250.688 244.969 249.82 256.177 246.465Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.176 259.397V274.039C256.176 274.039 203.307 273.337 195.537 274.039C191.248 270.353 184.014 260.819 181.044 249.258C185.584 251.641 196.967 255.23 207.987 258.043C220.629 261.266 248.9 263.764 256.176 259.397Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.177 217.105V246.463C248.7 248.702 218.813 249.83 198.69 245.995C197.269 242.415 199.996 239.273 201.226 238.673C200.056 233.565 204.528 233.344 208.383 231.126C214.302 221.656 220.149 223.652 222.353 224.099C227.927 218.919 233.016 222.026 235.905 223.431C238.867 219.659 243.756 218.544 246.849 220.472C249.871 222.358 251.849 217.731 256.177 217.105Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.769 210.793C158.769 210.793 192.746 223.022 200.413 225.189C208.081 227.355 217.578 230.628 221.225 233.97C224.033 234.953 226.391 233.587 226.391 233.587C226.391 233.587 230.718 238.903 237.177 236.017C240.594 237.992 245.364 239.133 249.7 236.094C251.909 237.081 256.176 236.473 256.176 236.473V241.64C256.176 241.64 254.338 243.692 247.654 244.147C240.969 244.603 234.135 245.058 230.867 243.768C227.603 242.479 225.565 240.542 208.843 235.638C193.49 231.135 158.769 219.987 158.769 219.987V210.793Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.785 225.188C253.411 225.456 252.279 226.252 251.113 227.32C249.947 227.588 247.224 226.077 245.7 228.652C244.003 228.12 240.628 225.715 236.543 229.627C234.944 227.32 230.331 226.962 229.178 229.627",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.708 157.319C273.994 157.319 279.09 152.222 279.09 145.933C279.09 139.645 273.994 134.547 267.708 134.547C261.422 134.547 256.325 139.645 256.325 145.933C256.325 152.222 261.422 157.319 267.708 157.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.074 153.467C271.559 154.553 269.708 155.191 267.708 155.191C262.602 155.191 258.453 151.037 258.453 145.933C258.453 140.83 262.602 136.68 267.708 136.68C269.708 136.68 271.554 137.314 273.069 138.399C272.223 138.089 271.303 137.923 270.35 137.923C265.933 137.923 262.342 141.515 262.342 145.933C262.342 150.352 265.933 153.944 270.35 153.944C271.308 153.944 272.223 153.774 273.074 153.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.975 141.569C201.298 141.523 201.635 141.561 201.92 141.718C204.549 143.161 204.728 152.326 200.09 153.386C195.184 154.509 196.163 147.775 196.869 145.894C198.192 142.382 200.103 141.693 200.975 141.569Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.772 141.552C183.972 140.301 180.955 149.303 183.091 152.117C185.227 154.926 188.746 153.015 189.346 148.818C189.801 145.604 190.282 142.378 187.772 141.552Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.25 205.613H256.177V273.879H320.25V205.613Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.374 221.344C304.952 221.344 305.421 220.875 305.421 220.297C305.421 219.719 304.952 219.25 304.374 219.25C303.796 219.25 303.327 219.719 303.327 220.297C303.327 220.875 303.796 221.344 304.374 221.344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.942 213.719L265.678 216.558L267.312 223.062",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.328 211.555L284.456 212.572L284.733 220.102C284.733 220.102 287.754 220.102 289.728 218.527",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.014 221.596L272.993 214.024C273.367 211.704 278.895 211.5 278.312 214.569C277.729 217.638 274.899 217.399 274.899 217.399L280.15 220.128",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.388 215.016L284.733 216.25",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.502 212.09C299.225 212.09 293.8 212.443 293.8 212.443L293.447 220.105L299.502 219.718",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.911 215.828L293.839 216.607",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.378 211.383L305.319 216.938",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.882 216.938L266.827 219.649",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.785 254.295L288.213 237.401C288.213 237.401 288.103 230.505 292.719 225.887C293.822 227.402 293.839 235.541 293.839 235.541C297.957 230.99 302.642 227.062 305.851 226.576C306.161 229.335 297.962 237.333 297.962 237.333C302.51 233.953 308.025 232.506 308.025 232.506C308.025 232.506 305.821 237.124 300.03 240.64C303.838 237.775 309.336 238.295 309.336 238.295C309.336 238.295 305.34 243.602 301.204 245.394C307.268 242.568 310.233 243.258 310.233 243.258C307.2 249.255 301.915 247.948 291.971 252.635C286.124 255.389 257.981 273.879 257.981 273.879L256.789 272.849V254.295H256.785Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.822 234.023L296.128 258.575C291.417 259.461 286.652 262.568 286.652 262.568C285.098 258.801 275.793 238.569 275.793 238.569C279.401 237.569 285.822 234.023 285.822 234.023Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.213 244.609L289.584 247.972L283.507 250.62L282.005 247.278L288.213 244.609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.352 64.4639C328.352 64.4639 330.794 97.1456 330.666 115.287C345.585 112.201 471.374 84.0227 471.374 84.0227L470.217 63.2891L328.352 64.4639Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.692 70.0329C337.692 70.0329 338.921 95.4103 342.198 105.166C342.772 96.9682 345.806 84.8328 345.806 84.8328C345.806 84.8328 347.691 96.4745 350.972 102.378C351.955 98.3601 355.478 69.2539 355.478 69.2539",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.993 70.8906L360.146 102.104",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.18 100.501L369.192 72.5019C369.192 69.8799 378.073 66.8322 378.073 75.124C378.073 82.143 379.175 99.5693 368.18 100.501Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.468 69.7188C388.136 69.6975 385.425 75.7035 385.421 81.9606C385.413 90.2694 390.357 97.6757 396.936 93.5597C399.863 91.8315 397.757 81.054 397.757 81.054L389.944 82.7012",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.632 69.2539L404.735 70.8927C404.735 70.8927 406.216 77.3881 406.484 93.065L416.777 88.8255",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.632 80.6172L406.131 83.5244",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.926 70.7276L435.223 67.8672",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.806 68.9531L429.445 88.0139",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.907 69.296C451.456 65.9078 444.64 67.4785 444.652 70.7688C444.669 75.7702 451.933 74.1357 455.303 73.7824C458.677 73.4291 457.933 81.2526 452.937 82.6615C445.601 84.7344 441.755 81.159 441.755 81.159",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.278 191.383L327.343 175.668C325.109 180.333 326.752 183.615 330.101 185.126C333.449 186.637 352.163 194.137 352.163 194.137L353.278 191.383Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.39 179.332L330.101 185.125",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.415 181.168L333.39 186.527",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.495 196.515C361.495 196.643 361.49 196.766 361.486 196.894H349.346C349.342 196.766 349.338 196.643 349.338 196.515C349.338 192.454 352.057 189.164 355.414 189.164C358.771 189.164 361.495 192.454 361.495 196.515Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52 196.898H361.495C361.495 192.837 363.963 189.547 367.005 189.547C370.052 189.547 372.52 192.837 372.52 196.898Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.332 196.895H372.66C373.158 193.728 374.911 191.383 376.996 191.383C379.081 191.383 380.834 193.728 381.332 196.895Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.251 196.895H381.677C382.4 193.728 384.94 191.383 387.962 191.383C390.987 191.383 393.527 193.728 394.251 196.895Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.13 196.891V196.895H409.011V196.891C409.011 193.038 411.501 189.914 414.569 189.914C417.641 189.914 420.13 193.038 420.13 196.891Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.636 196.895H427.904C428.019 193.328 430.377 190.48 433.27 190.48C436.159 190.48 438.521 193.328 438.636 196.895Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.584 195.347C455.503 195.845 455.46 196.36 455.46 196.892V196.896H445.159C445.418 193.499 447.712 190.848 450.507 190.848C452.86 190.848 454.856 192.729 455.584 195.347Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.511 196.891V196.895H455.856C455.818 196.355 455.724 195.835 455.584 195.346C456.052 192.396 457.843 190.195 459.983 190.195C462.485 190.195 464.511 193.196 464.511 196.891Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.052 182.027C450.733 177.847 458.886 168.526 461.749 168.457C463.486 168.415 464.507 172.041 464.507 172.041C464.507 172.041 459.145 181.866 449.052 182.027Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.461 134.297C453.073 125.546 457.699 116.96 461.715 118.246C464.885 119.259 462.877 123.404 460.954 125.414C456.154 130.428 448.461 134.297 448.461 134.297Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 126.873C442.319 118.658 447.013 108.379 451.706 108C453.604 108 453.544 115.96 442 126.873Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.418 138.413C358.508 130.104 354.533 123.898 351.295 123.898C346.581 123.898 352.848 136.681 359.418 138.413Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.028 198.973L432.274 177.231C441.895 173.579 459.005 159.719 461.579 150.5C463.894 142.212 452.022 146.579 449.052 151.125C446.082 155.671 437.619 164.133 433.342 164.759C433.789 153.977 434.593 137.313 433.61 131.154C432.632 125.016 427.909 115.302 415.084 114.145C402.259 112.987 376.196 123.76 373.575 132.588C370.192 143.996 377.158 164.184 380.524 172.327C375.626 171.08 354.87 155.22 348.01 154.326C341.151 153.437 337.411 161.635 345.874 169.207C354.338 176.779 367.609 181.683 384.621 183.198C384.889 185.335 389.43 200.127 389.43 200.127L431.028 198.973Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.995 155.663C400.944 155.663 404.956 151.649 404.956 146.699C404.956 141.748 400.944 137.734 395.995 137.734C391.046 137.734 387.034 141.748 387.034 146.699C387.034 151.649 391.046 155.663 395.995 155.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.527 148.567C401.663 151.355 399.059 153.386 395.995 153.386C392.229 153.386 389.161 150.321 389.161 146.55C389.161 143.477 391.204 140.867 394.004 140.012C392.187 141.097 390.97 143.085 390.97 145.354C390.97 148.784 393.761 151.581 397.195 151.581C399.45 151.581 401.433 150.372 402.527 148.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.079 153.222C422.028 153.222 426.04 149.208 426.04 144.257C426.04 139.306 422.028 135.293 417.079 135.293C412.13 135.293 408.118 139.306 408.118 144.257C408.118 149.208 412.13 153.222 417.079 153.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.398 146.859C422.373 149.34 419.926 151.094 417.079 151.094C413.313 151.094 410.245 148.025 410.245 144.258C410.245 141.41 411.994 138.967 414.471 137.941C413.182 139.099 412.373 140.776 412.373 142.641C412.373 146.127 415.207 148.966 418.696 148.966C420.564 148.966 422.241 148.153 423.398 146.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.004 170.384C396.689 173.904 400.323 175.628 407.701 175.066C414.126 174.576 419.011 172.108 421.858 169.226C423.407 167.66 425.858 162.833 424.16 160.351C423.683 159.653 422.87 159.266 422.032 159.219C418.394 159.006 414.381 163.139 411.105 163.548C404.85 164.331 404.956 162.726 397.527 163.467C397.191 163.501 396.85 163.552 396.544 163.692C394.123 164.808 394.025 168.396 395.004 170.384Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.876 174.761C397.867 174.084 396.055 172.586 395.004 170.385C394.025 168.398 394.123 164.809 396.54 163.694C396.85 163.554 397.191 163.503 397.527 163.469C398.131 163.409 398.684 163.362 399.195 163.328L400.876 174.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.858 169.226C421.811 169.273 421.764 169.319 421.717 169.362L419.951 159.504C420.654 159.291 421.351 159.176 422.032 159.214C422.875 159.265 423.683 159.653 424.16 160.347C425.858 162.832 423.407 167.655 421.858 169.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.905 175.049C407.837 175.053 407.769 175.061 407.701 175.066C406.071 175.189 404.624 175.206 403.339 175.108C402.756 172.235 401.425 165.616 400.952 163.267C402.956 163.25 404.199 163.462 405.514 163.611L407.905 175.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.194 173.424C413.603 174.036 411.824 174.517 409.884 174.815L407.735 163.77C408.65 163.778 409.722 163.723 411.105 163.548C411.696 163.472 412.313 163.276 412.947 163.008L415.194 173.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.13 170.726C419.241 171.399 418.228 172.025 417.1 172.587C416.543 169.718 415.432 164.035 415.024 161.949C416.207 161.281 417.424 160.545 418.637 160L420.13 170.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.004 170.384C396.689 173.904 400.323 175.628 407.701 175.066C414.126 174.576 419.011 172.108 421.858 169.226C423.407 167.66 425.858 162.833 424.16 160.351C423.683 159.653 422.87 159.266 422.032 159.219C418.394 159.006 414.381 163.139 411.105 163.548C404.85 164.331 404.956 162.726 397.527 163.467C397.191 163.501 396.85 163.552 396.544 163.692C394.123 164.808 394.025 168.396 395.004 170.384Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.478 257.746H329.943V265.655H352.478V257.746Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.771 63.9688H489.931V93.2324H629.771V63.9688Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.105 70.8623L511.36 70.3516",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.415 70.582C505.415 70.582 504.083 81.4915 506.275 85.6757",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.569 71.4873L603.823 70.9766",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.883 71.207C597.883 71.207 596.117 82.9423 598.309 87.1222",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.636 78.9036H524.521C524.521 78.9036 525.648 71.0715 520.606 70.0117C515.564 68.9518 513.04 75.7878 515.564 82.3556C518.083 88.9277 524.257 87.0676 525.248 83.2197",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.265 86.708C530.265 86.708 530.265 82.6983 530.265 76.3731C530.265 70.0479 537.431 68.0218 538.222 79.8847C538.222 68.9114 546.179 68.9582 546.179 77.5607C546.179 81.217 546.179 86.708 546.179 86.708",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.307 87.432L551.809 71.2955C563.085 68.8735 563.966 73.0662 562.081 75.833C559.596 79.4766 552.724 79.0126 552.724 79.0126",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.855 70.5625V86.699C572.931 86.699 573.569 85.039 573.569 85.039",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.352 87.428C579.352 87.428 578.433 72.6919 585.875 70.3125C590.364 72.7685 588.981 86.4703 588.981 86.7002",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.08 80.6406H588.867",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.432 78.8757L613.959 78.6374C613.959 72.7804 612.542 70.7798 609.104 70.567C605.01 70.3159 605.368 80.672 605.006 85.0562C604.776 87.8102 613.269 87.4314 613.538 82.762",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.482 72.8241C622.597 69.5593 617.563 71.3982 617.925 75.6504C618.329 80.4263 625.048 75.8548 625.358 80.8647C625.694 86.2833 619.635 86.8537 617.908 84.0614",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.592 178.748L607.529 267.049H489.931V102.781H607.529L604.662 105.991L599.432 111.839L599.164 112.133L594.066 117.837L593.637 118.318L588.747 123.783L587.76 124.885L582.607 130.649L582.514 130.751L577.263 136.625L576.897 137.034L571.71 142.835L570.493 144.193L565.285 150.02L565.149 150.169L559.808 156.141L558.983 157.065L553.838 162.82L553.736 162.935L548.898 168.34L539.592 178.748Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.588 152.933C544.904 152.933 552.456 145.379 552.456 136.06C552.456 126.742 544.904 119.188 535.588 119.188C526.273 119.188 518.721 126.742 518.721 136.06C518.721 145.379 526.273 152.933 535.588 152.933Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.396 145.696C547.984 145.696 551.702 141.976 551.702 137.387C551.702 132.798 547.984 129.078 543.396 129.078C538.809 129.078 535.09 132.798 535.09 137.387C535.09 141.976 538.809 145.696 543.396 145.696Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.469 164.289C538.805 167.043 541.677 171.891 541.677 177.408C541.677 182.656 539.078 187.296 535.095 190.105",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.216 222.249C510.092 210.671 524.163 210.513 528.516 220.789C532.376 229.893 532.112 248.55 532.112 248.55C532.112 248.55 545.371 236.185 550.315 233.716C552.609 232.566 567.072 230.983 569.416 239.109C571.101 244.953 568.293 253.607 568.293 253.607L566.046 243.829C566.046 243.829 565.753 250.687 562.472 252.372C561.664 248.775 560.766 244.617 560.766 244.617C560.766 244.617 560.43 249.563 556.945 253.607C555.149 249.448 554.473 244.617 554.473 244.617C554.473 244.617 547.618 260.221 532.674 267.053",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.027 114.769C604.951 115.037 601.628 113.233 599.432 111.841L604.661 105.992C605.934 107.742 607.934 111.202 607.027 114.769Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.24 120.501C599.296 120.752 596.249 119.177 594.066 117.837L599.164 112.133C600.423 113.98 602.078 117.194 601.24 120.501Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.321 126.088C593.547 126.318 590.862 125.033 588.747 123.786L593.636 118.32C594.811 120.214 596.075 123.117 595.321 126.088Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.952 133.425C587.952 133.685 584.799 132.016 582.607 130.65L587.76 124.887C589.028 126.7 590.815 130.016 589.952 133.425Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.93 139.595C582.828 139.867 579.454 138.016 577.263 136.624L582.513 130.75C583.786 132.474 585.845 135.981 584.93 139.595Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.161 145.672C577.131 145.936 573.906 144.212 571.71 142.837L576.897 137.035C578.169 138.823 580.041 142.198 579.161 145.672Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.803 152.904C570.752 153.168 567.48 151.406 565.285 150.022L570.493 144.195C571.761 145.966 573.697 149.384 572.803 152.904Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.782 159.315C565.583 159.6 561.983 157.553 559.808 156.144L565.149 150.172C566.378 151.768 568.753 155.48 567.782 159.315Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.144 165.567C559.157 165.826 556.03 164.179 553.838 162.821L558.983 157.066C560.247 158.888 562.004 162.179 561.144 165.567Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.328 170.561C553.596 170.787 550.987 169.561 548.898 168.343L553.736 162.938C554.881 164.832 556.064 167.662 555.328 170.561Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.541 181.725C551.443 183.815 549.085 186.773 547.332 188.693L542.49 182.521C544.435 181.576 548.192 180.209 551.541 181.725Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.174 188.428C556.081 190.386 554 193.115 552.298 195.03L547.575 189.012C549.613 188.092 553.064 187.024 556.174 188.428Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.638 195.235C560.553 197.023 558.821 199.445 557.221 201.309L552.698 195.537C554.766 194.711 557.843 193.975 560.638 195.235Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.923 201.807C566.829 203.821 564.634 206.638 562.906 208.554L558.136 202.471C560.14 201.539 563.715 200.36 566.923 201.807Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.119 207.83C572.021 209.95 569.608 212.946 567.855 214.862L562.991 208.664C564.91 207.711 568.723 206.298 572.119 207.83Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.088 214.577C576.995 216.62 574.731 219.498 572.995 221.422L568.191 215.301C570.174 214.356 573.825 213.1 577.088 214.577Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.096 222.102C582.999 224.166 580.692 227.082 578.948 229.002L574.123 222.855C576.084 221.914 579.786 220.603 583.096 222.102Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.526 228.17C588.424 230.388 585.777 233.576 584.012 235.47L579.067 229.166C580.854 228.234 584.922 226.544 588.526 228.17Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.522 235.795C593.428 237.796 591.262 240.593 589.543 242.512L584.777 236.438C586.79 235.515 590.335 234.357 593.522 235.795Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.419 242.397C597.338 244.142 595.675 246.496 594.113 248.343L589.637 242.635C591.7 241.835 594.696 241.167 597.419 242.397Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.9 249.021C602.819 250.766 601.155 253.12 599.594 254.967L595.117 249.259C597.181 248.463 600.172 247.79 602.9 249.021Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.002 255.649C607.921 257.394 606.257 259.748 604.695 261.595L600.219 255.887C602.283 255.087 605.274 254.414 608.002 255.649Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.392 130.715V241.704C612.265 241.108 588.028 216.488 588.028 186.212C588.028 159.229 607.274 136.742 632.784 131.741C635.903 131.132 639.111 130.779 642.392 130.715Z",
    fill: "#E7E5E4",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.391 120.531V130.717C639.111 130.781 635.902 131.134 632.783 131.743C607.274 136.744 588.028 159.232 588.028 186.214C588.028 216.491 612.265 241.11 642.391 241.706V251.658C606.193 251.658 576.85 222.305 576.85 186.095C576.85 149.884 606.193 120.531 642.391 120.531Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.89 152.847C632.32 150.685 630.247 149.251 628.013 149.357C624.537 149.519 620.133 151.349 618.793 155.767C616.954 161.816 623.571 164.655 627.843 162.987C631.264 161.646 634 157.057 632.89 152.847Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.067 168.728C585.543 168.962 583.594 172.546 583.377 174.87C583.041 178.479 584.382 183.098 589.245 183.749C596.326 184.698 599.968 180.271 598.726 175.589C597.73 171.839 592.973 168.268 588.067 168.728Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.194 148.561C596.683 148.906 593.675 152.12 593.458 154.44C593.122 158.049 595.896 161.629 599.415 162.25C605.159 163.268 607.525 158.986 607.525 154.142C607.529 150.404 603.606 147.953 599.194 148.561Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.878 134.573C612.729 135.199 610.491 138.459 610.58 140.575C610.721 143.865 613.576 146.734 616.725 146.857C621.865 147.057 623.414 142.911 622.826 138.553C622.375 135.19 618.652 133.475 614.878 134.573Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.391 129.348V140.444C641.396 141.504 639.966 142.122 638.017 142.036C634.869 141.904 632.013 138.695 631.877 135.017C631.839 134.043 632.196 132.851 632.784 131.74C633.618 130.148 634.915 128.713 636.179 128.301C638.532 127.534 640.86 127.99 642.391 129.348Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.206 167.745C610.993 168.068 608.325 170.993 608.125 173.099C607.815 176.377 610.248 179.612 613.35 180.165C618.414 181.068 620.516 177.173 620.533 172.78C620.55 169.384 617.095 167.179 613.206 167.745Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.411 190.873C598.083 191.214 595.283 194.279 595.075 196.492C594.747 199.931 597.309 203.324 600.568 203.907C605.887 204.856 608.1 200.77 608.117 196.16C608.129 192.597 604.504 190.282 600.411 190.873Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.392 189.017V203.289C641.596 203.497 640.69 203.54 639.664 203.387C636.388 202.889 633.766 199.258 634.035 195.457C634.205 193.009 636.954 189.506 639.277 189.029C640.366 188.808 641.421 188.812 642.392 189.017Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.392 211.161V225.429C641.596 225.638 640.69 225.68 639.664 225.527C636.388 225.029 633.766 221.402 634.035 217.597C634.205 215.154 636.954 211.646 639.277 211.174C640.362 210.952 641.421 210.957 642.392 211.161Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.392 168.775V180.74C641.345 181.272 640.03 181.477 638.422 181.238C635.145 180.757 632.486 177.458 632.707 174.04C632.852 171.84 635.558 168.72 637.873 168.32C639.511 168.035 641.085 168.222 642.392 168.775Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.605 190.459C617.98 190.697 616.023 192.838 615.874 194.383C615.644 196.788 617.435 199.159 619.712 199.564C623.431 200.228 624.975 197.371 624.988 194.149C625.001 191.663 622.465 190.046 619.605 190.459Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.95 216.244C613.397 216.5 610.397 219.271 610.223 221.314C609.951 224.489 612.857 227.703 616.457 228.324C622.333 229.337 624.66 225.613 624.558 221.339C624.486 218.036 620.435 215.797 615.95 216.244Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.35962 273.883H643",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.5 292.543H642.391",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.391 301.211H-2.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.069 273.883C100.163 282.098 101.805 301.206 101.805 301.206H73.9813C73.9813 301.206 71.8239 281.383 81.683 273.883C86.3041 273.883 108.069 273.883 108.069 273.883Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9847 277.238L87.5593 297.201",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.049 292.296C83.049 292.296 92.7463 296.808 94.0271 290.321C95.2015 284.379 85.1339 288.631 85.4148 284.57C85.6531 281.135 90.6571 281.076 94.4356 280.961",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.049 292.296C83.049 292.296 92.7463 296.808 94.0271 290.321C95.2015 284.379 85.1339 288.631 85.4148 284.57C85.6531 281.135 90.6571 281.076 94.4356 280.961",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.492 273.883C241.586 282.098 243.228 301.206 243.228 301.206H215.404C215.404 301.206 213.247 281.383 223.106 273.883C227.723 273.883 249.492 273.883 249.492 273.883Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.403 277.238L228.982 297.201",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.472 292.296C224.472 292.296 234.169 296.808 235.45 290.321C236.624 284.379 226.557 288.631 226.838 284.57C227.076 281.135 232.08 281.076 235.858 280.961",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.472 292.296C224.472 292.296 234.169 296.808 235.45 290.321C236.624 284.379 226.557 288.631 226.838 284.57C227.076 281.135 232.08 281.076 235.858 280.961",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.155 273.883C418.249 282.098 419.892 301.206 419.892 301.206H392.068C392.068 301.206 389.91 281.383 399.769 273.883C404.386 273.883 426.155 273.883 426.155 273.883Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.071 277.238L405.646 297.201",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.135 292.296C401.135 292.296 410.833 296.808 412.114 290.321C413.288 284.379 403.22 288.631 403.501 284.57C403.74 281.135 408.743 281.076 412.522 280.961",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.135 292.296C401.135 292.296 410.833 296.808 412.114 290.321C413.288 284.379 403.22 288.631 403.501 284.57C403.74 281.135 408.743 281.076 412.522 280.961",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.921 273.883C594.015 282.098 595.658 301.206 595.658 301.206H567.833C567.833 301.206 565.676 281.383 575.535 273.883C580.152 273.883 601.921 273.883 601.921 273.883Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.837 277.238L581.411 297.201",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.901 292.296C576.901 292.296 586.598 296.808 587.879 290.321C589.054 284.379 578.986 288.631 579.267 284.57C579.505 281.135 584.509 281.076 588.288 280.961",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.901 292.296C576.901 292.296 586.598 296.808 587.879 290.321C589.054 284.379 578.986 288.631 579.267 284.57C579.505 281.135 584.509 281.076 588.288 280.961",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.25 48.5H158.769V273.884H320.25V48.5Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.731 48.5H320.25V273.884H481.731V48.5Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 139.309V169.194V180.219V189.247V202.999V211.389V225.142V273.884H481.519V48.5H643V130.272",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.769 48.5H-2.5V273.884H158.769V48.5Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.987 196.898C470.187 202.56 468.757 207.719 466.821 212.405C466.17 213.988 465.464 215.517 464.702 216.994C451.86 241.886 424.241 251.752 406.28 251.752C388.144 251.752 360.886 242.231 348.202 216.994C347.457 215.517 346.764 213.988 346.125 212.405C344.245 207.723 342.836 202.568 342.028 196.898H470.987V196.898Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.821 212.402C466.17 213.986 465.464 215.514 464.702 216.991H348.202C347.457 215.514 346.764 213.986 346.125 212.402H466.821Z",
    fill: "#E2442F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_18959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrod7);
export default __webpack_public_path__ + "static/media/grod7.6b75b9c2d50d8245e8ab4f5f28520e9c.svg";
export { ForwardRef as ReactComponent };